import { render, staticRenderFns } from "./ThemeName.vue?vue&type=template&id=28db646a&"
import script from "./ThemeName.vue?vue&type=script&lang=js&"
export * from "./ThemeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports